/* eslint no-undef: 0 */
import Vue from "vue"
import Vuex from "vuex/dist/vuex.esm"
import mutations from "./mutations"
import actions from "./actions"
import moment from "@/plugins/moment"

Vue.use(Vuex)

const CurrentUser = window.CurrentUser || {}
const switchedAdmin = window.switched_admin

export const store = new Vuex.Store({
  state: {
    filter: {
      to: moment().format("YYYY-MM-DD"),
      from: moment().subtract(1, "year").format("YYYY-MM-DD"),
      radius: 30,
      location_ids: [],
      department_ids: [],
      is_employee: null,
      company_sizes: [],
      include_automatic: 'default',
      origin_sites: [],
      state: [],
      degrees: [],
      keyword: "",
      prefix: false,
      employee_types: [],
    },
    channels: [],
    departments: [],
    switched_admin: switchedAdmin,
    env: CurrentUser.env,
    user: {
      id: CurrentUser.id,
      name: CurrentUser.userName,
      company: CurrentUser.companyName,
      benchmarkEnabled: CurrentUser.benchmarkEnabled,
      logoUrl: CurrentUser.logoUrl,
      benchmarkRequired: CurrentUser.benchmarkRequired,
      benchmarkCurrent: CurrentUser.benchmarkCurrent,
      premiumStatus: CurrentUser.premiumStatus,
      isPartner: CurrentUser.isPartner,
      isAdmin: CurrentUser.isAdmin,
      participateCxp: CurrentUser.participateCxp,
      award: CurrentUser.award,
      locations: [],
    },
    structure: null,
    applicationMonths: {
      months: [],
    },
    returnRates: [],
    sampleSize: {
      myCount: null,
      totalCount: null,
      includeOld: false,
      companyCount: null,
    },
    CxpSize: {
      myCount: null,
      totalCount: null,
      companyCount: null,
    },
  },
  actions,
  mutations,
  getters: {
    returnRate: (state) => {
      const rates = state.returnRates
      if (rates.length === 0) return 0
      const applicationCount = rates.map(e => e.job_applications).reduce((a, b) => a + b, 0)
      const feedbackCount = rates.map(e => e.channel_survey_count).reduce((a, b) => a + b, 0)
      if (applicationCount === 0) return 0
      if (feedbackCount > applicationCount) return 100
      return Math.round(feedbackCount / applicationCount * 100)
    },
    isAdmin: (state) => state.user.isAdmin || state.switched_admin,
    jobApplicationsComplete: (state) => {
      if (!state.filter.from || !state.filter.to) return true

      return Object.keys(state.applicationMonths.months)
        .filter((e) => {
          const firstOfMonth = e.replace("/", "-") + "-01"
          return (
            firstOfMonth >= state.filter.from && firstOfMonth <= state.filter.to
          )
        })
        .map((key) => state.applicationMonths.months[key])
        .every((e) => e)
    },
  },
})
export default store
